import { AuthToken } from '@cobliteam/api-lib/src/account/session/AuthToken';
import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import useSessionStore from '@cobliteam/hooks/src/useSession/store/useSessionStore';
import useSessionQuery from '@cobliteam/hooks/src/useSession/useSessionQuery';
import useSyncUserDataSideEffects from '@cobliteam/hooks/src/useSession/useSyncUserDataSideEffects';
import type React from 'react';
import { Redirect } from 'react-router-dom';
import InitialLoadingPage from '../pages/LoadingPage/InitialLoadingPage';

interface PrivateRouterProviderProps {
  children: React.ReactNode;
}

const PrivateRouterProvider = ({ children }: PrivateRouterProviderProps) => {
  const session = useSessionStore((s) => s.session);
  const authToken = localStorage.getItem(AuthToken.ACCESS_TOKEN);

  // Revalida sessão em background contra /account/session. O `setSession` acontece dentro da
  // queryFn — quando a resposta chega, o `useAuthStore` atualiza atomicamente e o `useUserData`
  // abaixo já enxerga a sessão fresca sem esperar uma render cycle extra.
  useSessionQuery();

  const { useGetUserData } = useUser();
  const { data: userData } = useGetUserData();

  // Sincroniza o `userData` fresco nos stores/efeitos periféricos. Único ponto de mount para
  // evitar duplicação vs. consumidores múltiplos.
  useSyncUserDataSideEffects(userData, session?.user.id, session?.fleet.id);

  if (!authToken) return <Redirect to='/login' />;

  // Gate de boot: sem snapshot em localStorage (boot otimista revertido), o store começa vazio
  // e o loading fica visível até a revalidação de `/account/session` popular a sessão.
  if (session) return <>{children}</>;

  return <InitialLoadingPage />;
};

export default PrivateRouterProvider;
